import {
  TKIconArrowDown,
  TKIconClose,
  TKIconLogout,
  TKIconNavBtn,
  TKIconUser,
} from "assets/images/svgs";
import { useState } from "react";
import styled from "styled-components";
import { logout } from "appState/auth/authSlice";
import CompanyLogo from "../../shared/CompanyLogo";
import MakeDonation from "layout/modal/MakeDonation";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [showLogin, setShowLogin] = useState(false);
  const [showDonate, setShowDonate] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [toggleLogout, setToggleLogout] = useState(false);
  const [showDonateModal, setshowDonateModal] = useState(false);

  const { isAuthenticated, ngoProfile, ngo, donor } = useSelector(
    (state) => state.auth
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNavigate = () => {
    let path = "";
    if (ngo !== null) {
      path = "/ngo/dashboard";
    } else {
      path = "/donor";
    }
    navigate(path);
  };

  const donateOptions = [
    {
      title: "Donate items",
      path: "/donate-items/category",
    },
    {
      title: "Donate money",
      path: "/donate-money",
    },
  ];

  const loginOptions = [
    {
      title: "NGO",
      path: "/auth/ngo/login",
    },
    {
      title: "Donor",
      path: "/auth/donor/login",
    },
  ];

  const signupOptions = [
    {
      title: "NGO",
      path: "/auth/ngo/signup",
    },
    {
      title: "Donor",
      path: "/auth/donor/signup",
    },
  ];

  return (
    <div>
      <MakeDonation
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        onClose={() => {
          setshowDonateModal(false);
          setCurrentStep(0);
        }}
        isOpen={showDonateModal}
      />
      <NavBarContainer>
        <CompanyLogo text="...closing the needs gap in Africa" />
        <NavIconContainer>
          {isAuthenticated && (
            <div className="relative">
              <div
                onClick={() => setToggleLogout(!toggleLogout)}
                className="cursor-pointer relative flex items-center gap-2"
              >
                <div className="w-[45px] bg-white h-[45px] rounded-full flex justify-center items-center">
                  <p className="text-[24px] font-medium text-[#213874]">
                    {ngoProfile?.ngoProfile?.name.split(" ")[0].charAt(0)}
                    {ngoProfile?.ngoProfile?.name.split(" ")[1].charAt(0)}
                    {donor?.donor?.fullName.split(" ")[0].charAt(0)}
                    {donor?.donor?.fullName.split(" ")[1].charAt(0)}
                  </p>
                </div>
                <TKIconArrowDown />
              </div>
              {toggleLogout && (
                <div className="fixed rounded-md bg-white flex flex-col items-start right-2">
                  <div className="flex flex-col items-start">
                    <div
                      onClick={handleNavigate}
                      className="cursor-pointer border-b py-2 px-3 flex justify-center items-center gap-2"
                    >
                      <TKIconUser className="fill-black stroke-black" />
                      <p className="text-black hover:font-medium whitespace-nowrap">
                        Go to Dashboard
                      </p>
                    </div>
                    <div
                      onClick={() => {
                        dispatch(logout());
                        navigate("/");
                      }}
                      className="cursor-pointer py-2 px-3  flex justify-center items-center gap-2"
                    >
                      <TKIconLogout />
                      <p className="text-red-500 hover:font-medium">Logout</p>
                    </div>
                  </div>
                  <div
                    onClick={() => setToggleLogout(false)}
                    className="fixed inset-0 -z-10"
                  ></div>
                </div>
              )}
            </div>
          )}
          <TKIconNavBtn
            className="hover:cursor-pointer"
            onClick={() => setToggle(true)}
          />
        </NavIconContainer>
        <NavBtnContainer>
          <NavBarWrapper>
            <NavBtnDiv>
              <NavLink to="/about">ABOUT</NavLink>
            </NavBtnDiv>
            <div className="relative">
              <NavBtnDiv
                onClick={() => {
                  setShowDonate(!showDonate);
                  setShowLogin(false);
                  setShowSignup(false);
                }}
              >
                <p>DONATE</p>
                <TKIconArrowDown />
              </NavBtnDiv>
              {showDonate && (
                <WrapperDiv className="fixed p-4 rounded-md">
                  <div
                    onClick={() => setShowDonate(false)}
                    className="fixed inset-0 -z-10"
                  ></div>
                  <div className="flex flex-col gap-2">
                    {donateOptions.map((donateOption, index) => (
                      <Link key={index} to={donateOption.path}>
                        <p className="whitespace-nowrap cursor-pointer hover:font-medium">
                          {donateOption.title}
                        </p>
                      </Link>
                    ))}
                  </div>
                </WrapperDiv>
              )}
            </div>
            <NavBtnDiv>
              <NavLink to="/projects">PROJECTS</NavLink>
            </NavBtnDiv>
          </NavBarWrapper>
          <NavBarWrapper>
            {isAuthenticated ? null : (
              <div className="flex gap-3 items-center">
                <div className="relative">
                  <NavBtnDiv
                    onClick={() => {
                      setShowLogin(!showLogin);
                      setShowDonate(false);
                      setShowSignup(false);
                    }}
                  >
                    <TKIconUser />
                    <p>LOGIN</p>
                    <TKIconArrowDown />
                  </NavBtnDiv>
                  {showLogin && (
                    <WrapperDiv className="fixed py-2 px-8 rounded-md">
                      <div
                        onClick={() => setShowLogin(false)}
                        className="fixed inset-0 -z-10"
                      ></div>
                      <div className="flex flex-col gap-2">
                        {loginOptions.map((loginOption, index) => (
                          <Link key={index} to={loginOption.path}>
                            <p className="whitespace-nowrap cursor-pointer hover:font-medium">
                              {loginOption.title}
                            </p>
                          </Link>
                        ))}
                      </div>
                    </WrapperDiv>
                  )}
                </div>
                <div className="relative">
                  <NavBtnDiv
                    onClick={() => {
                      setShowSignup(!showSignup);
                      setShowDonate(false);
                      setShowLogin(false);
                    }}
                  >
                    <p>SIGN UP</p>
                    <TKIconArrowDown />
                  </NavBtnDiv>
                  {showSignup && (
                    <WrapperDiv className="fixed py-2 px-8 rounded-md">
                      <div
                        onClick={() => setShowSignup(false)}
                        className="fixed inset-0 -z-10"
                      ></div>
                      <div className="flex flex-col gap-2">
                        {signupOptions.map((signupOption, index) => (
                          <Link key={index} to={signupOption.path}>
                            <p className="whitespace-nowrap cursor-pointer hover:font-medium">
                              {signupOption.title}
                            </p>
                          </Link>
                        ))}
                      </div>
                    </WrapperDiv>
                  )}
                </div>
              </div>
            )}
            <NavBtnDiv onClick={() => setshowDonateModal(true)}>
              <DonateBtn>DONATE NOW</DonateBtn>
            </NavBtnDiv>
            {isAuthenticated && (
              <div className="relative">
                <div
                  onClick={() => setToggleLogout(!toggleLogout)}
                  className="cursor-pointer relative flex items-center gap-2"
                >
                  <div className="w-[45px] bg-white h-[45px] rounded-full flex justify-center items-center">
                    <p className="text-[24px] font-medium text-[#213874]">
                      {ngoProfile?.ngoProfile?.name.split(" ")[0].charAt(0)}
                      {ngoProfile?.ngoProfile?.name.split(" ")[1].charAt(0)}
                      {donor?.donor?.fullName.split(" ")[0].charAt(0)}
                      {donor?.donor?.fullName.split(" ")[1].charAt(0)}
                    </p>
                  </div>
                  <TKIconArrowDown />
                </div>
                {toggleLogout && (
                  <div className="fixed rounded-md bg-white flex flex-col items-start right-2">
                    <div className="flex flex-col items-start">
                      <div
                        onClick={handleNavigate}
                        className="cursor-pointer border-b py-2 px-3 flex justify-center items-center gap-2"
                      >
                        <TKIconUser className="fill-black stroke-black" />
                        <p className="text-black hover:font-medium whitespace-nowrap">
                          Go to Dashboard
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          dispatch(logout());
                          navigate("/");
                        }}
                        className="cursor-pointer py-2 px-3  flex justify-center items-center gap-2"
                      >
                        <TKIconLogout />
                        <p className="text-red-500 hover:font-medium">Logout</p>
                      </div>
                    </div>
                    <div
                      onClick={() => setToggleLogout(false)}
                      className="fixed inset-0 -z-10"
                    ></div>
                  </div>
                )}
              </div>
            )}
          </NavBarWrapper>
        </NavBtnContainer>
        <div
          className={
            "fixed bg-[#13234b] top-0 right-0 h-screen transition-all duration-500 delay-200 z-50 " +
            (toggle ? "w-[250px]" : "w-0")
          }
        >
          {toggle && (
            <div
              onClick={() => {
                if (toggle === true) {
                  setToggle(false);
                }
              }}
              className="fixed inset-0 -z-20"
            ></div>
          )}
          <div className="flex flex-col">
            <div className="flex ml-auto items-center h-[71px] border-b border-[#817e7e]">
              <div onClick={() => setToggle(false)}>
                <TKIconClose className="w-20 cursor-pointer" />
              </div>
            </div>
            <div className="flex items-start gap-12 ml-8 mt-8 flex-col">
              <NavBtnDiv>
                <NavLink to="/about">ABOUT</NavLink>
              </NavBtnDiv>
              <div className="relative">
                <NavBtnDiv
                  onClick={() => {
                    setShowDonate(!showDonate);
                    setShowLogin(false);
                    setShowSignup(false);
                  }}
                >
                  <p>DONATE</p>
                  <TKIconArrowDown />
                </NavBtnDiv>
                {showDonate && (
                  <WrapperDiv className="fixed z-10 py-2 px-8 rounded-md">
                    <div className="flex flex-col gap-2">
                      {donateOptions.map((donateOption, index) => (
                        <Link key={index} to={donateOption.path}>
                          <p className="whitespace-nowrap cursor-pointer hover:font-medium">
                            {donateOption.title}
                          </p>
                        </Link>
                      ))}
                    </div>
                  </WrapperDiv>
                )}
              </div>
              <NavBtnDiv>
                <NavLink to="/projects">PROJECTS</NavLink>
              </NavBtnDiv>
              {isAuthenticated ? null : (
                <div className="flex flex-col gap-12 items-center">
                  <div className="relative">
                    <NavBtnDiv
                      onClick={() => {
                        setShowLogin(!showLogin);
                        setShowDonate(false);
                        setShowSignup(false);
                      }}
                    >
                      <TKIconUser />
                      <p>LOGIN</p>
                      <TKIconArrowDown />
                    </NavBtnDiv>
                    {showLogin && (
                      <WrapperDiv className="fixed z-10 py-2 px-8 rounded-md">
                        <div className="flex flex-col gap-2">
                          {loginOptions.map((loginOption, index) => (
                            <Link key={index} to={loginOption.path}>
                              <p className="whitespace-nowrap cursor-pointer hover:font-medium">
                                {loginOption.title}
                              </p>
                            </Link>
                          ))}
                        </div>
                      </WrapperDiv>
                    )}
                  </div>
                  <div className="relative">
                    <NavBtnDiv
                      onClick={() => {
                        setShowSignup(!showSignup);
                        setShowDonate(false);
                        setShowLogin(false);
                      }}
                    >
                      <p>SIGN UP</p>
                      <TKIconArrowDown />
                    </NavBtnDiv>
                    {showSignup && (
                      <WrapperDiv className="fixed py-2 px-8 rounded-md">
                        <div className="flex flex-col gap-2">
                          {signupOptions.map((signupOption, index) => (
                            <Link key={index} to={signupOption.path}>
                              <p className="whitespace-nowrap cursor-pointer hover:font-medium">
                                {signupOption.title}
                              </p>
                            </Link>
                          ))}
                        </div>
                      </WrapperDiv>
                    )}
                  </div>
                </div>
              )}
              <NavBtnDiv
                onClick={() => {
                  setshowDonateModal(true);
                  setToggle(false);
                }}
              >
                <DonateBtn>DONATE NOW</DonateBtn>
              </NavBtnDiv>
            </div>
            <div className="absolute bottom-5 left-[25%] flex justify-center items-center">
              <CompanyLogo />
            </div>
          </div>
        </div>
      </NavBarContainer>
    </div>
  );
};

export default Navbar;

const NavBarContainer = styled.div`
  /* position: -webkit-sticky; */
  position: fixed;
  width: 100%;
  top: 0;
  background: linear-gradient(90deg, #42528e -44.03%, #011f5b 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 4rem;
  color: white;
  z-index: 20;
  overflow: hidden;

  @media screen and (max-width: 450px) {
    padding: 1rem 2rem;
  }
`;
const WrapperDiv = styled.div`
  background: linear-gradient(90deg, #42528e -44.03%, #011f5b 100%);
`;
const NavBtnContainer = styled.div`
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;
const NavIconContainer = styled.div`
  display: none;
  gap: 10px;

  @media screen and (max-width: 1010px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const NavBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;
const NavBtnDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 5px;
  margin: 0 7px;

  :hover {
    font-weight: 500;
    transition-delay: 300ms;
  }
`;
const DonateBtn = styled.p`
  white-space: nowrap;
  background: linear-gradient(#011f5b, #011f5b) padding-box,
    linear-gradient(to right, #f57200, #f0ca18);
  border-radius: 50px;
  border: 2px solid transparent;
  padding: 0.5rem 0.8rem;
`;
